goog.provide('el8.util.event');


el8.util.event = (function() {

    return {
        isNotNavKey: function(keycode) {
            return (keycode !== KEYS.ESC) &&
                (keycode !== KEYS.UP) && (keycode !== KEYS.DOWN) &&
                (keycode !== KEYS.ENTER) && (keycode !== KEYS.TAB);
        },

        listenFn: function(triggerMap) {
            return function(event) {
                var $target = $(event.target);
                for (var t in triggerMap) {
                    if (triggerMap.hasOwnProperty(t)) {
                        var $active_target = $target.closest('.'+t);
                        if ($active_target.length) {
                            var retVal = triggerMap[t]($active_target);
                            // Return value from fn, if available
                            if (retVal !== undefined) { return retVal; }
                            // Else, propagate
                            return true;
                        }
                    }
                }
            };
        }

    };

})();
